module.exports = __webpack_public_path__ + "img/card-amex.033591cc.png";